import client from "../modules/client";

export const prepareUpload = ({directory, file_name, file_type, meta_type="user_photo", ...props}) => {
  return client(`/api/v0/media/prepareUpload`, {method:'post', body: {
    directory: directory,
    file_name: file_name,
    file_type: file_type,
    meta_type: meta_type,
  }}).then(({ data }) => data);
};

export function useMediaService () {
  return {
    prepareUpload,
  };
}
